import {Cureus} from '../Cureus';

Cureus.AdminResourceHistory = {};

//= require_tree ./AdminResourceHistory
